import { render } from "./DangerButton.vue?vue&type=template&id=14a33af7"
import script from "./DangerButton.vue?vue&type=script&lang=js"
export * from "./DangerButton.vue?vue&type=script&lang=js"
script.render = render

export default script